import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const SydneyIcon = ()=>/*#__PURE__*/ _jsxs("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M15.5724 13.067H17.4122C17.9512 11.649 19 9.90038 19 9.90038C17.4059 10.0992 16.0632 10.6122 14.9714 11.2215C15.1981 11.7972 15.4008 12.409 15.5724 13.067Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M16.3389 6.51601C16.2876 6.50144 15.812 6.37161 15.0349 6.37161C14.3446 6.37161 13.3787 6.48181 12.2584 6.89347C13.24 7.93151 14.14 9.24187 14.8341 10.8873L17.1002 6.73387L16.3389 6.51601Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M2.98933 13.0672L1.75053 8.11264C1.19447 8.00434 0.8341 8.00054 0.789767 8.00054H0L1.12607 13.0672H2.98933Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M1.8997 6.10041L3.64136 13.0671H5.4926L3.7028 6.37337C3.20436 6.26634 2.8687 6.22137 2.81676 6.21504L1.8997 6.10041Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M14.9148 13.0671C12.5303 4.29673 4.56547 3.57537 4.4825 3.5684L3.59077 3.5L6.1488 13.0671H14.9148Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M4.43342 14.9666H3.16675V14.3333H4.43342V14.9666ZM14.5668 14.9666H8.23342V14.3333H14.5668V14.9666Z",
                fill: "#595AD4"
            }),
            /*#__PURE__*/ _jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.1001 14.3333C17.1001 14.1559 17.1001 13.9722 17.1001 13.6999H1.26675V15.5999H17.1001V14.3333ZM3.16675 14.9666H4.43342V14.3333H3.16675V14.9666ZM8.23342 14.9666H14.5668V14.3333H8.23342V14.9666Z",
                fill: "#595AD4"
            })
        ]
    });
